const ATTRS = ['data-uid', 'data-end-date', 'data-location', 'data-start-date', 'data-title'];

export class CalendarBoxHTMLElement extends HTMLElement {
    private icsFileURL: string;

    static get observedAttributes(): string[] {
        return ATTRS;
    }

    public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (!ATTRS.includes(name)) {
            return;
        }

        if (oldValue === newValue) {
            return;
        }

        const uid = this.getAttribute('data-uid');
        const endDate = this.getAttribute('data-end-date');
        const location = this.getAttribute('data-location');
        const startDate = this.getAttribute('data-start-date');
        const title = this.getAttribute('data-title');
        this.createICSFile(uid, endDate, location, startDate, title);
    }

    private createICSFile(uid: string, endDate: string, location: string, startDate: string, title: string): void {
        const ics =
`BEGIN:VCALENDAR
CALSCALE:GREGORIAN
METHOD:PUBLISH
PRODID:-//Reply/eventcal//NONSGML v1.0//EN
VERSION:2.0
BEGIN:VEVENT
UID:${uid}
${startDate ? `DTSTART;VALUE=DATE:${startDate}\n` : ''}${endDate ? `DTEND;VALUE=DATE:${endDate}\n` : ''}SUMMARY:${title}\n${location ? `LOCATION:${location}\n` : ''}END:VEVENT
END:VCALENDAR`;

        const file = new File([ics], 'test-ics', { type: 'text/calendar' });

        if (this.icsFileURL) {
            window.URL.revokeObjectURL(this.icsFileURL);
        }
        this.icsFileURL = window.URL.createObjectURL(file);

        this.querySelector('a').href = this.icsFileURL;
    }

    public disconnectedCallback(): void {
        if (this.icsFileURL) {
            window.URL.revokeObjectURL(this.icsFileURL);
        }
    }
}